// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

export const TranslationFragmentDoc = `
    fragment translation on Translation {
  translation
  token
}
    `;